import React, { useEffect } from "react";
import { Route, Routes, Navigate, MemoryRouter, useLocation } from "react-router-dom";
import ListArtifact from "./ArtifactsList";
import ArtifactTypes from "./create/Artifacttypes";
import CreateArtifactContextLayout from "./create/CreateArtifactContextLayout";
import SelectTopic from "./create/SelectTopic";
import AgeRating from "./create/AgeRating";
import CertifyContent from "./create/CertifyContent";
import Publish from "./create/Publish";
import CreateImageContent from "./create/CreateImage";
import SuccessContentSubmit from "./create/SuccessSubmit";
import CreateArtifact from "./create/container/CreateArtifact";

import TextArtifactContainer from "./create/container/TextArtifactContainer";
import DocumentArtifactContainer from "./create/container/DocumentAtrifactContainer";
// import CreateArtifactEventContainer from "./create/container/createArtifactEventContainer";
import AddGreetings from "./create/AddGreetings";
import AddStory from "./create/AddStory";
import AddGuide from "./create/AddGuide";
import AddPolls from "./create/AddPolls";
import CreatePhoto from "./create/CreatePhoto";
import CreateAudio from "./create/CreateAudio";
import CreateVideo from "./create/CreateVideo";
import CreateLinkContent from "./create/CreateLink";
import AddEvent from "./create/AddEvent";
import AddDocument from "./create/AddDocument";
import AddPlace from "./create/AddPlace";
import AddLetter from "./create/AddLetter";
import AddList from "./create/AddList";
import AddJournal from "./create/AddJournal";
import StatusHistory from "../contentModeration/StatusHistory";
import { useAuth } from "../../context/AuthContext";
import { useNavigationBar } from "../../context/NavigationContext";
import { UpdateListProvider } from "../contentModeration/UpdateListContext";
import EditArtifactContextLayout from "./create/EditArtifactContextLayout";
import EditArtifact from "./create/container/EditArtifact";
import AddJournalVoice from "./create/AddJournalVoice";
import AddJournalMemo from "./create/AddJournalMemo";

const Artifact = () => {
  const context = useAuth();
  const location = useLocation();
  const path = location.pathname;
  const { backgroundLocation } = useNavigationBar();
  //const state = location.state as { backgroundLocation?: Location };
  const oldLocation = backgroundLocation?.pathname.includes("dashboard/content") ? backgroundLocation : location;

  // useEffect(() => {
  //   if(path !== '/list' || path !== '/'){

  //   }
  // }, [context, path]);

  return (
    <>
      <UpdateListProvider>
        <Routes location={oldLocation}>
          <Route path="/" element={<Navigate replace to="./list" />} />
          <Route path="/list" element={<ListArtifact />} />

          <Route element={<CreateArtifactContextLayout />}>
            <Route path="/list/:id" element={<CreateArtifact />} />
            <Route path="/list/:id/history" element={<StatusHistory />} />

            <Route path="/create" element={<ArtifactTypes />} />
            {/** container starts here */}
            <Route path="/createContent" element={<CreateArtifact />} />
            {/* <Route path="/list/:id/editContent/*" element={<EditContent />} /> */}
            {/** container ends here */}
            <Route path="/list/:id/selectTopic" element={<SelectTopic />} />
            <Route path="/list/:id/ageRating" element={<AgeRating />} />
            <Route path="/list/:id/certifyContent" element={<CertifyContent />} />
            <Route path="/list/:id/publish" element={<Publish />} />
            <Route path="/list/:id/successSubmit" element={<SuccessContentSubmit />} />
            <Route path="/list/:id/createStory" element={<CreateImageContent />} />
            <Route path="/list/:id/addPhotos" element={<CreatePhoto />} />
            <Route path="/list/:id/addEvent" element={<AddEvent />} />
            <Route path="/list/:id/addDocument" element={<AddDocument />} />
            <Route path="/list/:id/addLink" element={<CreateLinkContent />} />
            <Route path="/list/:id/addVideo" element={<CreateVideo />} />
            <Route path="/list/:id/addAudio" element={<CreateAudio />} />
            {/* <Route path="/addGreeting" element={<GreetingEditor />} /> */}
            <Route path="/list/:id/addGreeting" element={<AddGreetings />} />
            <Route path="/list/:id/addPlace" element={<AddPlace />} />
            <Route path="/list/:id/addLetter" element={<AddLetter />} />
            <Route path="/list/:id/addList" element={<AddList />} />
            <Route path="/list/:id/addJournal" element={<AddJournal />} />
            <Route path="/list/:id/addJournalVoice" element={<AddJournalVoice />} />
            <Route path="/list/:id/addJournalMemo" element={<AddJournalMemo />} />
            <Route path="/list/:id/addStory" element={<AddStory />} />
            <Route path="/list/:id/addGuide" element={<AddGuide />} />
            <Route path="/list/:id/addPolls" element={<AddPolls />} />
            <Route path="/list/:id/history" element={<StatusHistory />} />
          </Route>
          <Route element={<EditArtifactContextLayout />}>
            <Route path="/list/:id/edit" element={<EditArtifact />} />
            <Route path="/list/:id/edit/selectTopic" element={<SelectTopic />} />
            <Route path="/list/:id/edit/ageRating" element={<AgeRating />} />
            <Route path="/list/:id/edit/certifyContent" element={<CertifyContent />} />
            <Route path="/list/:id/edit/publish" element={<Publish />} />
            <Route path="/list/:id/edit/successSubmit" element={<SuccessContentSubmit />} />
            <Route path="/list/:id/edit/createStory" element={<CreateImageContent />} />
            <Route path="/list/:id/edit/addPhotos" element={<CreatePhoto />} />
            <Route path="/list/:id/edit/addEvent" element={<AddEvent />} />
            <Route path="/list/:id/edit/addDocument" element={<AddDocument />} />
            <Route path="/list/:id/edit/addLink" element={<CreateLinkContent />} />
            <Route path="/list/:id/edit/addVideo" element={<CreateVideo />} />
            <Route path="/list/:id/edit/addAudio" element={<CreateAudio />} />
            {/* <Route path="/addGreeting" element={<GreetingEditor />} /> */}
            <Route path="/list/:id/edit/addGreeting" element={<AddGreetings />} />
            <Route path="/list/:id/edit/addPlace" element={<AddPlace />} />
            <Route path="/list/:id/edit/addLetter" element={<AddLetter />} />
            <Route path="/list/:id/edit/addList" element={<AddList />} />
            <Route path="/list/:id/edit/addJournal" element={<AddJournal />} />
            <Route path="/list/:id/edit/addJournalVoice" element={<AddJournalVoice />} />
            <Route path="/list/:id/edit/addJournalMemo" element={<AddJournalMemo />} />
            <Route path="/list/:id/edit/addStory" element={<AddStory />} />
            <Route path="/list/:id/edit/addGuide" element={<AddGuide />} />
            <Route path="/list/:id/edit/addPolls" element={<AddPolls />} />
            <Route path="/list/:id/edit/history" element={<StatusHistory />} />
          </Route>
        </Routes>
        {backgroundLocation && (
          <Routes>
            <Route element={<CreateArtifactContextLayout />}>
              <Route path="/list/:id" element={<CreateArtifact />} />
              <Route path="/list/:id/history" element={<StatusHistory />} />
              <Route path="/create" element={<ArtifactTypes />} />
              {/** container starts here */}
              <Route path="/createContent" element={<CreateArtifact />} />
              {/** container ends here */}
              <Route path="/list/:id/selectTopic" element={<SelectTopic />} />
              <Route path="/list/:id/ageRating" element={<AgeRating />} />
              <Route path="/list/:id/certifyContent" element={<CertifyContent />} />
              <Route path="/list/:id/publish" element={<Publish />} />
              <Route path="/list/:id/successSubmit" element={<SuccessContentSubmit />} />
              <Route path="/list/:id/createStory" element={<CreateImageContent />} />
              <Route path="/list/:id/addPhotos" element={<CreatePhoto />} />
              <Route path="/list/:id/addEvent" element={<AddEvent />} />
              <Route path="/list/:id/addDocument" element={<AddDocument />} />
              <Route path="/list/:id/addLink" element={<CreateLinkContent />} />
              <Route path="/list/:id/addVideo" element={<CreateVideo />} />
              <Route path="/list/:id/addAudio" element={<CreateAudio />} />
              <Route path="/list/:id/addGreeting" element={<AddGreetings />} />
              <Route path="/list/:id/addPlace" element={<AddPlace />} />
              <Route path="/list/:id/addLetter" element={<AddLetter />} />
              <Route path="/list/:id/addList" element={<AddList />} />
              <Route path="/list/:id/addJournal" element={<AddJournal />} />
              <Route path="/list/:id/addJournalVoice" element={<AddJournalVoice />} />
              <Route path="/list/:id/addJournalMemo" element={<AddJournalMemo />} />
              <Route path="/list/:id/addStory" element={<AddStory />} />
              <Route path="/list/:id/addGuide" element={<AddGuide />} />
              <Route path="/list/:id/addPolls" element={<AddPolls />} />
              <Route path="/list/:id/history" element={<StatusHistory />} />
            </Route>
            <Route element={<EditArtifactContextLayout />}>
              {/* <Route path="/editContent/:id/*" element={<EditContent />} /> */}
              <Route path="/list/:id/edit/" element={<EditArtifact />} />
              <Route path="/list/:id/edit/selectTopic" element={<SelectTopic />} />
              <Route path="/list/:id/edit/ageRating" element={<AgeRating />} />
              <Route path="/list/:id/edit/certifyContent" element={<CertifyContent />} />
              <Route path="/list/:id/edit/publish" element={<Publish />} />
              <Route path="/list/:id/edit/successSubmit" element={<SuccessContentSubmit />} />
              <Route path="/list/:id/edit/createStory" element={<CreateImageContent />} />
              <Route path="/list/:id/edit/addPhotos" element={<CreatePhoto />} />
              <Route path="/list/:id/edit/addEvent" element={<AddEvent />} />
              <Route path="/list/:id/edit/addDocument" element={<AddDocument />} />
              <Route path="/list/:id/edit/addLink" element={<CreateLinkContent />} />
              <Route path="/list/:id/edit/addVideo" element={<CreateVideo />} />
              <Route path="/list/:id/edit/addAudio" element={<CreateAudio />} />
              {/* <Route path="/addGreeting" element={<GreetingEditor />} /> */}
              <Route path="/list/:id/edit/addGreeting" element={<AddGreetings />} />
              <Route path="/list/:id/edit/addPlace" element={<AddPlace />} />
              <Route path="/list/:id/edit/addLetter" element={<AddLetter />} />
              <Route path="/list/:id/edit/addList" element={<AddList />} />
              <Route path="/list/:id/edit/addJournal" element={<AddJournal />} />
              <Route path="/list/:id/edit/addJournalVoice" element={<AddJournalVoice />} />
              <Route path="/list/:id/edit/addJournalMemo" element={<AddJournalMemo />} />
              <Route path="/list/:id/edit/addStory" element={<AddStory />} />
              <Route path="/list/:id/edit/addGuide" element={<AddGuide />} />
              <Route path="/list/:id/edit/addPolls" element={<AddPolls />} />
              <Route path="/list/:id/edit/history" element={<StatusHistory />} />
            </Route>
          </Routes>
        )}
      </UpdateListProvider>
    </>
  );
};

// export const EditContent = () => {
//   const context = useAuth();
//   const location = useLocation();

//   const { backgroundLocation } = useNavigationBar();
//   const oldLocation = backgroundLocation || location;

//   return (
//     <>
//       {/* <Routes location={oldLocation}>
//           <Route element={<CreateContentContextLayout />}>
//             <Route path="/" element={<ContentView />} />
//             <Route path="/topic" element={<ContentTopic />} />
//             <Route path="/age" element={<ContentAge />} />
//             <Route path="/certification" element={<ChanneCertification />} />
//           </Route>
//         </Routes> */}

//       <Routes>
//         <Route path="/" element={<CreateArtifact />} />
//         {/** container ends here */}
//         <Route path="/list/:id/selectTopic" element={<SelectTopic />} />
//         <Route path="/list/:id/ageRating" element={<AgeRating />} />
//         <Route path="/list/:id/certifyContent" element={<CertifyContent />} />
//         <Route path="/list/:id/publish" element={<Publish />} />
//         <Route path="/list/:id/successSubmit" element={<SuccessContentSubmit />} />
//         <Route path="/list/:id/createStory" element={<CreateImageContent />} />
//         <Route path="/list/:id/addPhotos" element={<CreatePhoto />} />
//         <Route path="/list/:id/addEvent" element={<AddEvent />} />
//         <Route path="/list/:id/addDocument" element={<AddDocument />} />
//         <Route path="/list/:id/addLink" element={<CreateLinkContent />} />
//         <Route path="/list/:id/addVideo" element={<CreateVideo />} />
//         <Route path="/list/:id/addAudio" element={<CreateAudio />} />
//         {/* <Route path="/addGreeting" element={<GreetingEditor />} /> */}
//         <Route path="/list/:id/addGreeting" element={<AddGreetings />} />
//         <Route path="/list/:id/addPlace" element={<AddPlace />} />
//         <Route path="/list/:id/addLetter" element={<AddLetter />} />
//         <Route path="/list/:id/addList" element={<AddList />} />
//         <Route path="/list/:id/addJournal" element={<AddJournal />} />
//         <Route path="/list/:id/addStory" element={<AddStory />} />
//         <Route path="/list/:id/addGuide" element={<AddGuide />} />
//         <Route path="/list/:id/addPolls" element={<AddPolls />} />
//         <Route path="/list/:id/history" element={<StatusHistory />} />
//         {/* <Route
//             path="/createEvent"
//             element={<CreateArtifactEventContainer />}
//           />
//           <Route
//             path="/createDocument"
//             element={<CreateArtifactDocumentContainer />}
//           /> */}
//       </Routes>
//     </>
//   );
// };

export default Artifact;
